export const USUARIOS_LOADING = "USUARIOS_LOADING";
export const USUARIOS_SET_PAGE = "USUARIOS_SET_PAGE";
export const USUARIOS_SET_PERPAGE = "USUARIOS_SET_PERPAGE";
export const USUARIOS_SET_TOTAL = "USUARIOS_SET_TOTAL";
export const USUARIOS_SET_USUARIOS = "USUARIOS_SET_SELECT_EMPRESA";
export const USUARIOS_SET_FILTRO = "USUARIOS_SET_FILTRO";
